import React from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { COLOR_KICK_BLUE } from "~/shared/sharedConstants";

export default function SleepFollowUpBillingNotice({
  terms,
  accepted,
  loading,
  onAccept,
  onDecline,
  error,
}) {
  return (
    <Dialog
      open={Boolean(error || (!loading && terms?.disclosure && !accepted))}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      aria-labelledby="sleep-restart-title"
      aria-describedby="sleep-restart-description"
      PaperProps={{ sx: { borderRadius: 3, margin: 2 } }}
    >
      <DialogTitle
        id="sleep-restart-title"
        sx={{ pt: 3, color: COLOR_KICK_BLUE }}
      >
        Please note...
      </DialogTitle>
      <DialogContent>
        {error ? (
          <Alert id="sleep-restart-description" severity="error">
            {error}
          </Alert>
        ) : (
          <DialogContentText
            id="sleep-restart-description"
            sx={{ color: "text.primary", whiteSpace: "pre-line" }}
          >
            {terms?.disclosure?.Body}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions
        disableSpacing
        sx={{
          px: 3,
          pb: 3,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          "& .MuiButton-root": { width: "100%", textTransform: "none" },
        }}
      >
        <Button
          variant="contained"
          size="large"
          disableElevation
          disabled={Boolean(loading || error || !terms?.disclosure)}
          onClick={onAccept}
          sx={{ backgroundColor: COLOR_KICK_BLUE }}
        >
          {terms?.disclosure?.CheckboxLabel || "Proceed"}
        </Button>
        <Button variant="outlined" size="large" onClick={onDecline}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
